module.exports = __webpack_public_path__ + "img/katarina_bedrooms_4.9c4205ee.jpg";